// src/components/nodes/DocumentNode.js
import { NodeBase } from './NodeBase';

export class DocumentNode extends NodeBase {
  constructor() {
    super('document', { 
      title: '文档标题',
      description: '文档描述信息...'
    });
  }

  renderContent(data, selected) {
    return (
      <div className="document-content">
        <div className="document-icon">📄</div>
        <div className="document-title">
          {data.title || '文档'}
        </div>
        <div className="document-desc">
          {data.description || '文档描述'}
        </div>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '文档节点',
      icon: '📄',
      defaultData: this.defaultData
    };
  }
}